<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">Transfer To Mobile Money</h2>
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters">
            <div class="col-12">
              <div class="add-balance">
                <div class="ctl-inner">
                  <span class="crtl icon-add_money_1"></span>
                </div>
                <div>
                  <span class="bal-txt">Balance</span>
                  <span class="bal_amount">{{UsertBal.currentBalance}} {{UsertBal.currency}}</span>
                </div>
              </div>
              <div style="float:right;">
                <button type="button" class="btn btn-primary" (click)="openAddBeneficiaryDetails()">
                  Add Beneficiary Details
                </button>
              </div>
            </div>
            <div class="col-12 form-padding">
              <form class="example-form" (ngSubmit)="openDialog(mobileMoneyForm.value)"
                    [formGroup]="mobileMoneyForm">

                <div class="row no-gutters">
                  <div class="col-md-12">
                    <div class="row no-gutters">
                      <div class="col-12">
                        <mat-radio-group class="example-radio-group" formControlName="PaymentModeCode">
                          <mat-radio-button *ngFor="let x of OptionList?.addmoneyservice" [value]="x.code">{{x.name}}</mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Country</mat-label>
                          <mat-select formControlName="AccountCode" required>
                            <mat-form-field>
                              <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                            </mat-form-field>
                            <mat-option [value]="d?.code" *ngFor="let d of filterCountry(); let i=index" (click)="getBeneficiaryInfo(d?.code)">
                              <img matSuffix [src]="d?.icon" style="height: 20px;width: 20px;" />
                              {{d?.name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.Accountcode?.errors?.required">
                            Select Country is required
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <mat-label>Select Beneficiary </mat-label>
                          <mat-select formControlName="Id" required>
                            <mat-form-field>
                              <input matInput [formControl]="BeneficiaryFilterCtrl" placeholder="Search" />
                            </mat-form-field>
                            <mat-option [value]="d?.id" *ngFor="let d of filterBeneficiary(); let i=index" (click)="GetBeneficiaryInfobyId(d?.id,d?.value,d?.channel,d?.beneficiary_country,d?.beneficiary_phone)">

                              <!--{{d?.beneficiary_country}}-{{d?.channel}}-{{d?.beneficiary_fname}} {{d?.beneficiary_lname}}-->
                              {{d?.text}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.Id?.errors?.required">
                            Select Beneficiary is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-12">
                        <mat-form-field class="example-full-width mb-0">
                          <input matInput placeholder="Enter Amount in USD(eg:100 or eg:0.00)"
                                 formControlName="Amount" Numberonly maxlength="9" required>
                          <mat-error *ngIf="submitted && f.Amount?.errors?.required">
                            Amount is required
                          </mat-error>
                        </mat-form-field>

                        <div class="row payable-amount justify-content-around align-items-center mb-4 mt-0">
                          <div class="col-4" *ngIf="amt">
                            <p><b>Service Charges + Platform Charges(USD)</b></p>
                            <p>{{commissionFee|number}}
                          </div>
                          <div class="col-4" *ngIf="amt">

                            <p><b>Net Amount In USD</b></p>
                            <p>{{commissionTotal|number}}
                          </div>
                          <div class="col-4 text-right" *ngIf="amt">
                            <p><b>Receiveable Amount In {{payoutCurrency}}</b></p>

                            <p>{{ActualAmount|number}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="Account Description (eg:Kofi's account)"
                                 formControlName="Comment" maxlength="200" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <button class="primary-btn" type="submit"> SUBMIT</button>
                  </div>
                  <div class="col-12">
                    <p><b>Once a new amount is entered or payment method is changed, the exchange rate and fees will be recalculated</b></p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>
    <div class="two-card recent-card common-padding pay-money shadow overflow-auto">
      <h2 class="heading recent-head">Recent Transaction</h2>
      <table class="table table-hover text-center  table-bordered">
        <thead>
          <tr>
            <th>Service Name</th>

            <th>Mobile No.</th>
            <th>Amount</th>
            <th>Transaction Status</th>
          </tr>
        </thead>

        <tbody *ngFor="let x of userorderdetailList; let i=index">
          <tr *ngIf="i<10">
            <td>
              {{x.serviceName}}
            </td>

            <td>{{x.destination}}</td>
            <td>{{x.amount}}</td>
            <td>{{x.transactionRemark}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</fieldset>
